import { render, staticRenderFns } from "./ModalCloseIcon.vue?vue&type=template&id=3bfc74dd"
import script from "./ModalCloseIcon.vue?vue&type=script&lang=js"
export * from "./ModalCloseIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports